export const googleMapsApiToken: string = 'AIzaSyC4MZlyIN-0oFzEN-oYbXlNxAsIQ9TybyM';
